import { Note } from 'app/models/note-params'
import * as types from './types'
import { createReducer } from 'app/state/utils'
import { ContractType } from 'app/models/common-types'

export interface NoteState {
  dealNote?: Note[] | null
  facilityNote?: Note[] | null
  entityNote?: Note[] | null
  principalNote?: Note[] | null
  paymentNote?: Note[] | null
  feeNote?: Note[] | null
  subTradeNote?: Note[] | null
  masterTradeNote?: Note[] | null
}

const initialState: NoteState = {
  dealNote: [],
  facilityNote: [],
  entityNote: [],
  principalNote: [],
  paymentNote: [],
  feeNote: [],
  subTradeNote: [],
  masterTradeNote: [],
}

const notesReducer = createReducer(initialState)({
  [types.GET_NOTES_BY_CONTRACT]: (state: any, payload: any) => {
    if (payload.payload.length === 0) {
      return state
    }
    return {
      dealNote:
        payload.payload[0].contractType === ContractType.Deals
          ? payload.payload
          : state.dealNote,
      facilityNote:
        payload.payload[0].contractType === ContractType.Facilities
          ? payload.payload
          : state.facilityNote,
      entityNote:
        payload.payload[0].contractType === ContractType.Entities
          ? payload.payload
          : state.entityNote,
      principalNote:
        payload.payload[0].contractType === ContractType.Principals
          ? payload.payload
          : state.principalNote,
      paymentNote:
        payload.payload[0].contractType === ContractType.Payments
          ? payload.payload
          : state.paymentNote,
      feeNote:
        payload.payload[0].contractType === ContractType.Fees
          ? payload.payload
          : state.feeNote,
    }
  },
  [types.ADD_NOTE]: (state: any, payload: any) => {
    return {
      dealNote:
        payload.payload.contractType === ContractType.Deals
          ? [...state.dealNote, payload.payload]
          : state.dealNote,
      facilityNote:
        payload.payload.contractType === ContractType.Facilities
          ? [...state.facilityNote, payload.payload]
          : state.facilityNote,
      entityNote:
        payload.payload.contractType === ContractType.Entities
          ? [...state.entityNote, payload.payload]
          : state.entityNote,
      principalNote:
        payload.payload.contractType === ContractType.Principals
          ? [...state.principalNote, payload.payload]
          : state.principalNote,
      paymentNote:
        payload.payload.contractType === ContractType.Payments
          ? [...state.paymentNote, payload.payload]
          : state.paymentNote,
      feeNote:
        payload.payload.contractType === ContractType.Fees
          ? [...state.feeNote, payload.payload]
          : state.feeNote,
    }
  },
  [types.EDIT_NOTE]: (state: any, payload: any) => {
    const { contractType } = payload.payload
    let notes = []
    switch (contractType) {
      case ContractType.Deals:
        notes = state.dealNote
        break
      case ContractType.Facilities:
        notes = state.facilityNote
        break
      case ContractType.Entities:
        notes = state.entityNote
        break
      case ContractType.Principals:
        notes = state.principalNote
        break
      case ContractType.Payments:
        notes = state.paymentNote
        break
      case ContractType.Fees:
        notes = state.feeNote
        break
    }
    const index = notes.findIndex(
      (note: Note) => note.id === payload.payload.id,
    )
    notes[index] = payload.payload

    return {
      dealNote:
        payload.payload.contractType === ContractType.Deals
          ? notes
          : state.dealNote,
      facilityNote:
        payload.payload.contractType === ContractType.Facilities
          ? notes
          : state.facilityNote,
      entityNote:
        payload.payload.contractType === ContractType.Entities
          ? notes
          : state.entityNote,
      principalNote:
        payload.payload.contractType === ContractType.Principals
          ? notes
          : state.principalNote,
      paymentNote:
        payload.payload.contractType === ContractType.Payments
          ? notes
          : state.paymentNote,
      feeNote:
        payload.payload.contractType === ContractType.Fees
          ? notes
          : state.feeNote,
    }
  },

  [types.SET_NULL]: (state: any, payload: any) => {
    return {
      dealNote:
        payload.payload.contractType === ContractType.Deals
          ? []
          : state.dealNote,
      facilityNote:
        payload.payload.contractType === ContractType.Facilities
          ? []
          : state.facilityNote,
      entityNote:
        payload.payload.contractType === ContractType.Entities
          ? []
          : state.entityNote,
      principalNote:
        payload.payload.contractType === ContractType.Principals
          ? []
          : state.principalNote,
      paymentNote:
        payload.payload.contractType === ContractType.Payments
          ? []
          : state.paymentNote,
      feeNote:
        payload.payload.contractType === ContractType.Fees ? [] : state.feeNote,
    }
  },
})

export default notesReducer
